import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
// import * as _ from 'lodash';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { getWindowConfig } from 'config';
import { compose, withProps } from 'recompose';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { getApps } from 'api/appApi';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import Confirm from 'components/elements/confirm-element';
import { deleteOne } from 'api/cosoApi';
import Message from 'rc-message';
import { withRouter } from 'react-router-dom';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';
import moment from 'moment';
import { COLOR } from 'config';
import { IS_ENTERPRISE } from 'config';

const MyMapComponent = compose(
  withProps({}),
  withScriptjs,
  withGoogleMap
)((props) => (
  <GoogleMap
    defaultMapTypeId='hybrid'
    defaultZoom={10}
    defaultCenter={
      props.mapLocation
        ? props.mapLocation
        : { lat: 11.1073184, lng: 106.6822954 }
    }
  >
    {props.mapLocation && (
      <Marker
        position={props.mapLocation}
        //position={{ lat: 11.1073184, lng: 106.6822954 }}
      />
    )}
  </GoogleMap>
));

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

class RowValue extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  render() {
    return (
      <div>
        <Row>
          <Col xs={5}>{this.props.label}</Col>
          <Col xs={7}>{this.props.value}</Col>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

@PageLockHOC(['facility.view'])
class CosoPanel extends React.Component {
  static propTypes = {
    initialValue: PropTypes.object,
  };

  state = {
    urlBilling: null,
  };

  componentDidMount = async () => {
    const response = await getApps();

    if (response && response.success) {
      const urlBilling = _.get(response, ['data', 'domains', 'billing']);

      console.log(this.props.initialValue);

      this.setState({
        urlBilling,
      });
    }
  };

  getInitialValue = (keyPath, defaultValue = '') => {
    const value = _.result(this.props.initialValue, keyPath, defaultValue);
    return value === '-- Select --' ? '' : value;
  };

  renderLinkBilling = () => {
    const { initialValue } = this.props;
    const { urlBilling } = this.state;

    const isPaidFee = initialValue.isPaidFee;

    if (!isPaidFee) return 'Chưa thực hiện đóng phí';

    return (
      <a target='_blank' href={urlBilling}>
        {urlBilling}
      </a>
    );
  };

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      this.ConfirmElm.showConfirm({
        content: (
          <React.Fragment>
            <p>
              Bạn có muốn xoá Tên cơ sở/dự án:{' '}
              {this.getInitialValue('FacilityNameFull')}
            </p>
            <p>
              Sau khi xóa dữ liệu, thông tin về Tên cơ sở/dự án và dữ liệu liên
              quan sẽ <b style={{ color: 'orange' }}>không thể khôi phục</b>.
              Hãy chắc chắn bạn muốn xóa Tên cơ sở/dự án này.
            </p>
          </React.Fragment>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.CO_SO.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };
  getPermitNumber = () => {
    const LicenseNumber = _.compact(this.getInitialValue('LicenseNumber', []));
    const LicenseNumberUsed = _.compact(
      this.getInitialValue('LicenseNumberUsed', [])
    );
    const value =
      LicenseNumber.join(', ').substring(0, Number.MAX_VALUE) +
      `${
        LicenseNumberUsed.length > 0 && LicenseNumber.length > 0 ? ', ' : ''
      } ` +
      LicenseNumberUsed.join(', ');

    return value;
  };

  render() {
    const mapLocation =
      this.getInitialValue('Latitude') && this.getInitialValue('Longitude')
        ? {
            lat: this.getInitialValue('Latitude'),
            lng: this.getInitialValue('Longitude'),
          }
        : null;

    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <Clearfix height={8} />
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            <Link to={slug.CO_SO.LIST}>
              <Icon
                style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                icon={IconNames.CIRCLE_ARROW_LEFT}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.SUCCESS}
              />
            </Link>

            <Permissions allowed={[`facility.write`]}>
              <Fragment>
                <Clearfix width={8} />
                <Link
                  to={slug.CO_SO.EDIT_WITH_ID + this.getInitialValue('_id')}
                >
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.MANUALLY_ENTERED_DATA}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.PRIMARY}
                  />
                </Link>
              </Fragment>
            </Permissions>

            <Permissions allowed={[`facility.delete`]}>
              <Fragment>
                <Clearfix width={8} />
                <Icon
                  style={{ cursor: 'pointer' }}
                  icon={IconNames.BAN_CIRCLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                  onClick={this.handelDelete}
                />
              </Fragment>
            </Permissions>
          </div>
        </HeaderContainer>
        <Clearfix height={8} />
        <Row>
          <Col xs={6}>
            <RowValue
              label='Tên cơ sở/dự án'
              value={this.getInitialValue('FacilityNameFull')}
            />
            {!IS_ENTERPRISE && (
              <RowValue
                label='Tên doanh nghiệp'
                value={this.getInitialValue('organizationName')}
              />
            )}
            <RowValue
              label='Số giấy phép chứng nhận đăng ký doanh nghiệp'
              value={this.getInitialValue('BusinessLicenseNumber')}
            />
            <RowValue
              label='Mã số thuế (Mã số doanh nghiệp)'
              value={this.getInitialValue('taxNumber')}
            />
            <RowValue
              label={IS_ENTERPRISE ? 'Phân khu' : 'KCN/CCN'}
              value={this.getInitialValue('industrialArea.Name')}
            />
            {!IS_ENTERPRISE && (
              <RowValue
                label='Thẩm quyền quản lý môi trường'
                value={this.getInitialValue('authority.Name')}
              />
            )}
            <RowValue
              label='Tình trạng hoạt động'
              value={this.getInitialValue('businessActivity.label')}
            />

            <RowValue
              label='Ngành/Nghề'
              value={this.getInitialValue('sector.Name')}
            />
            <RowValue
              label='Điện thoại'
              value={this.getInitialValue('Telephone')}
            />
            <RowValue label='Fax' value={this.getInitialValue('Fax')} />
            <RowValue
              label='Diện tích (m²)'
              value={this.getInitialValue('Aream2')}
            />
            <RowValue
              label='Vĩ độ (WGS84)'
              value={this.getInitialValue('Latitude')}
            />
            <RowValue
              label='Kinh độ (WGS84)'
              value={this.getInitialValue('Longitude')}
            />
            <RowValue
              label='Vĩ độ (VN2000)'
              value={this.getInitialValue('LatitudeVN2000')}
            />
            <RowValue
              label='Kinh độ (VN2000)'
              value={this.getInitialValue('LongitudeVN2000')}
            />

            {!IS_ENTERPRISE && (
              <RowValue
                label='Quận/Huyện'
                value={this.getInitialValue('district.Name')}
              />
            )}
            {!IS_ENTERPRISE && (
              <RowValue
                label='Phường/Xã'
                value={this.getInitialValue('Commune')}
              />
            )}
            <RowValue
              label='Địa chỉ'
              value={this.getInitialValue('Address1')}
            />
            {!IS_ENTERPRISE && (
              <RowValue
                label='Nguồn tiếp nhận 2'
                value={this.getInitialValue('ReceviedSource_2.Name')}
              />
            )}
            {!IS_ENTERPRISE && (
              <RowValue
                label='Nguồn tiếp nhận 1'
                value={this.getInitialValue('ReceviedSource_1.Name')}
              />
            )}
            <RowValue
              label={IS_ENTERPRISE ? 'Loại nước thải' : 'Nguồn thải'}
              value={this.getInitialValue('WasteSources')}
            />
            <RowValue
              label='Tiêu chuẩn đấu nối nước thải theo SLA'
              value={this.getInitialValue('WastewaterSLAConnectionStandard')}
            />
            <RowValue
              label='Tiêu chuẩn đấu nối nước thải theo ĐTM'
              value={this.getInitialValue('WastewaterDTMConnectionStandard')}
            />
            <RowValue
              label='Lưu lượng nước thải đăng ký theo ĐTM của DN (m3/ngày )'
              value={this.getInitialValue('RegisteredFlowRateDTM')}
            />
            <RowValue label='Ghi chú' value={this.getInitialValue('Note')} />
            {!IS_ENTERPRISE && (
              <Row>
                <Col xs={5}>
                  <b>Thông tin thu phí </b>
                </Col>
                <Col>{this.renderLinkBilling()}</Col>
              </Row>
            )}
            <Clearfix height={8} />
            <Row>
              <Col xs={5}>
                <b>Cán bộ phụ trách môi trường</b>
              </Col>
            </Row>
            <Clearfix height={8} />
            <RowValue
              label='Họ và tên'
              value={this.getInitialValue('PContactFirst')}
            />
            <RowValue
              label='Điện thoại'
              value={this.getInitialValue('PContactTel')}
            />
            <RowValue
              label='Email'
              value={this.getInitialValue('PContactEmail')}
            />
            <Row>
              <Col xs={5}>
                <b>Người đại diện pháp luật </b>
              </Col>
            </Row>
            <Clearfix height={8} />
            <RowValue
              label='Họ và tên'
              value={this.getInitialValue('SContactFirst')}
            />
            <RowValue
              label='Điện thoại'
              value={this.getInitialValue('SContactTel')}
            />
            <RowValue
              label='Email'
              value={this.getInitialValue('SContactEmail')}
            />
            <Clearfix height={8} />

            {!IS_ENTERPRISE && (
              <React.Fragment>
                <Row>
                  <Col xs={5}>
                    <b>Quản lý thông tin giấy phép</b>
                  </Col>
                </Row>
                <Clearfix height={8} />
                <RowValue label='Số giấy phép' value={this.getPermitNumber()} />
                <RowValue
                  label='Thêm vào'
                  value={`${
                    this.getInitialValue('AddedOn')
                      ? moment(this.getInitialValue('AddedOn')).format(
                          'DD/MM/YYYY HH:mm'
                        ) +
                        ' bởi ' +
                        this.getInitialValue('AddedBy')
                      : ''
                  } `}
                />
                <RowValue
                  label='Cập nhật lần cuối'
                  value={`${
                    this.getInitialValue('UpdatedOn')
                      ? moment(this.getInitialValue('UpdatedOn')).format(
                          'DD/MM/YYYY HH:mm'
                        ) +
                        ' bởi ' +
                        this.getInitialValue('UpdatedBy')
                      : ''
                  }`}
                />
              </React.Fragment>
            )}
          </Col>
          <Col xs={6}>
            <MyMapComponent
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${
                getWindowConfig().googleApiKey
              }&v=3.exp&language=vi&libraries=geometry,drawing,places`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `400px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
              key='map'
              mapLocation={mapLocation}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(CosoPanel);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/CosoPanel/index.js